var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4165 1.08353C12.1945 1.86157 12.1945 3.12302 11.4165 3.90106L4.05846 11.2591C3.7393 11.5782 3.33939 11.8047 2.9015 11.9141L0.619328 12.4847C0.254548 12.5759 -0.0758704 12.2455 0.0153246 11.8807L0.585868 9.5985C0.69534 9.16061 0.921762 8.7607 1.24092 8.44154L8.59894 1.08353C9.37698 0.30549 10.6384 0.30549 11.4165 1.08353ZM7.89448 3.19657L1.94531 9.14592C1.75381 9.33742 1.61796 9.57736 1.55227 9.8401L1.18307 11.3169L2.6599 10.9477C2.92264 10.882 3.16258 10.7462 3.35407 10.5547L9.30303 4.60513L7.89448 3.19657ZM9.30332 1.78791L8.59875 2.4923L10.0073 3.90085L10.7121 3.19668C11.1011 2.80766 11.1011 2.17693 10.7121 1.78791C10.3231 1.39889 9.69234 1.39889 9.30332 1.78791Z",
    fill: "#FD7900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/editPen.7dafced08df42e02f5fcd44503ff24ce.svg";
export { ForwardRef as ReactComponent };